// src/features/inventory/utils/inventoryHelpers.js

/**
 * تبدیل ارقام فارسی و عربی به ارقام انگلیسی
 */
export const toEnglishDigits = (input) => {
  if (input === null || input === undefined) return "";
  return String(input)
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 1776))
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 1632));
};

/**
 * تبدیل ایمن به عدد به همراه مقدار بازگشتی پیش‌فرض در صورت نامعتبر بودن ورودی
 */
export const safeNumber = (val, fallback = null) => {
  if (val === null || val === undefined || String(val).trim() === "") {
    return fallback;
  }
  const cleanVal = toEnglishDigits(val).replace(/,/g, ""); // حذف کامای احتمالی جداکننده هزارگان
  const num = Number(cleanVal);
  return Number.isNaN(num) ? fallback : num;
};

/**
 * تفسیر مقادیر متنی اکسل به مقدار بولین
 */
export const parseBoolean = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "boolean") return value;

  const text = String(value).trim().toLowerCase();
  return ["true", "1", "yes", "فعال", "بله", "ok"].includes(text);
};

/**
 * نرمال‌سازی ورودی‌ها به رشته‌های عددی تمیز جهت استفاده در فرم‌ها و محاسبات کلاینت
 */
export const normalizeNumber = (value, fallback = "") => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return fallback;
  }
  return toEnglishDigits(value).replace(/,/g, "").trim();
};
